import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import GrossTotalTransacPresenter from "./GrossTotalTransacPresenter";
import Export from "../../../../components/Export";
import printChart from "../../../../PrintChart";
import DefaultState from "../../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../../components/InitialPrompt";
import SalesGrowthReport from "./components/SalesGrowthReport";
import YearSelect from "../../../discount-cost/salesDiscountAmount/components/YearSelect";
import MonthSelect from "./components/MonthSelect";
import { exportGrossSalesTransactionsCSV } from "./utils/grossSalesTransactionCsvUtils";
import {
  getSalesTransactionGrowthChartData,
  getSalesTransactionGrowthChartOptions,
} from "./utils/salesTransactionGrowthUtils";
import monthsUtil from "./utils/monthsUtils";
import ProgressLoader from "../../../../components/ProgressLoader";
import PageHeader from "../../../../components/PageHeader";
import CustomSelect from "../../../../components/CustomSelect";

class GrossTotalTransacPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new GrossTotalTransacPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: [],
      selectedStoreCode: "",
      selectedMonth: "",
      selectedYear: "",
      store: [],
      storess: "",
      range: "",
      selectedMonth: "",
      selectedMonthName: "",
      notFound: false,
    };
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", ""),
    );

    return [...new Set(storeCodes)];
  }

  handleDropdownChange(event) {
    const monthNames = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };
    let monthName;
    this.setState({ selectedMonth: event.target.value });

    if (event.target.value === "AllMonths") {
      this.presenter.onChangeDate("AllMonths");
    } else {
      this.setState({ range: event.target.value });
      this.presenter.onChangeDate(JSON.parse(event.target.value));
      const monthi = JSON.parse(event.target.value).$gte.split("-");
      monthName = Object.keys(monthNames).find(
        (key) => monthNames[key] === monthi[1],
      );
    }

    this.setState({ selectedMonthName: monthName });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  handleYearChange = (event) => {
    const year = event.target.value;

    let parsedRange = JSON.parse(this.state.range);

    parsedRange.$gte =
      year + parsedRange.$gte.substring(parsedRange.$gte.indexOf("-"));
    parsedRange.$lte =
      year + parsedRange.$lte.substring(parsedRange.$lte.indexOf("-"));

    this.presenter.onChangeDate(parsedRange);
    this.setState({ selectedYear: event.target.value });
  };

  exportToCSV = () => {
    const {
      selectedMonth,
      selectedYear,
      storess,
      selectedStoreCode,
      selectedMonthName,
      objects,
    } = this.state;
    // const chartData = this.chartData();
    const chartData = getSalesTransactionGrowthChartData({
      transactions: objects,
      selectedStoreCode,
      selectedMonthName,
      selectedYear,
    });

    console.log("chartDatachartData", chartData);

    exportGrossSalesTransactionsCSV({
      chartData,
      storess,
      selectedMonth,
      selectedYear,
      // fileName: 'MyReport.csv', // optional override
    });
  };

  exportChartAsPDFs = () => {
    setTimeout(() => {
      window.print();
    }, 500);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const {
      objects,
      selectedStoreCode,
      selectedMonth,
      selectedMonthName,
      selectedYear,
    } = this.state;

    const chartData = getSalesTransactionGrowthChartData({
      transactions: objects,
      selectedStoreCode,
      selectedMonthName,
      selectedYear,
    });

    console.log("Objects: ", objects);
    console.log("chartData: ", chartData);
    const chartOptions = getSalesTransactionGrowthChartOptions(chartData);
    const months = monthsUtil(selectedYear);
    const chartId = "chart-container6";
    const formatSales = (sales) => {
      return sales.toLocaleString("en-US", {
        style: "currency",
        currency: "PHP",
      });
    };
    const storeOptions = [
      { value: "AllStore", label: "All Store" },
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode,
    );

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <PageHeader
            title="Gross Sales vs. Total Transaction"
            subtitle="Compare revenue performance against transaction volume"
            icon="bi bi-bar-chart-steps"
          />
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col-sm-4">
            <CustomSelect
              label="Store"
              options={storeOptions}
              onChange={(opt) => this.onChangeStore(opt.value)}
              // isDisabled={range}
              // error={range ? "Please select a date range first" : ""}
              icon="bi bi-shop"
              placeholder="Select Store"
              isClearable={true}
            />
          </div>

          <MonthSelect
            selectedMonth={selectedMonth}
            selectedMonthName={selectedMonthName}
            months={months}
            onChange={this.handleDropdownChange}
          />

          <YearSelect
            selectedYear={this.state.selectedYear}
            onChange={this.handleYearChange.bind(this)}
            yearsCount={3}
            className="col-sm-3"
          />
        </div>
        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />{" "}
        {this.state.objects && this.state.objects.length > 0 && (
          <SalesGrowthReport
            chartData={chartData}
            chartOptions={chartOptions}
            formatSales={formatSales}
            selectedStoreCode={selectedStoreCode}
            chartRef={this.chartRef6}
            containerId="chart-container6"
          />
        )}
        {this.state.notFound && (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        )}
        {this.state.objects?.length === 0 &&
          this.state.storess &&
          this.state.selectedMonthName &&
          this.state.selectedYear &&
          !this.state.notFound && (
            <div className="text-center mt-5">
              <DefaultState />
            </div>
          )}
        {!this.state.selectedYear && <InitialPrompt twoFilter={false} />}
      </>
    );
  }
}

export default withRouter(GrossTotalTransacPage);
